import { rgba } from 'polished';
import styled from 'styled-components';

export const Header = styled('header')`
    min-height: 7.2rem;
    height: max-content;
    box-sizing: border-box;
    background-color: white;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 2.4rem;
    padding: 2.4rem;
    position: relative;
    box-shadow: 0 0.2rem 0.8rem ${({ theme }) => rgba(theme.colors.grey[500], 0.2)};
    @media (min-width: ${({ theme }) => theme.breakpoints.M.min}px) {
        padding: 2.4rem 4rem;
    }
`;

export const LeftSide = styled('div')`
    flex: 1;
    min-width: calc(50% - 1.2rem);
    display: flex;
    align-items: center;
    & > * {
        margin-right: ${({ theme }) => theme.spacing.S2};
    }
`;

export const RightSide = styled(LeftSide)`
    justify-content: right;
    & > * {
        margin-left: ${({ theme }) => theme.spacing.S2};
    }
`;
